import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import AdminNav from "./AdminNav";

const Deposit = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");

  useEffect(() => {
    const fetchUsersData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/auth/all-v-users`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          setUsers(data?.users);
          setFilteredUsers(data?.users);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersData();
  }, [token]);

  useEffect(() => {
    setFilteredUsers(
      searchTerm.trim()
        ? users.filter(
            (user) =>
              user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user.email.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : users
    );
  }, [searchTerm, users]);

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />
        <div className="search-add-main">
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>Balance</th>
                <th>Deposit</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr key={user._id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>
                      {user.balances?.fiat?.length === 0 &&
                        user.balances?.crypto?.length === 0 && (
                          <div>No Balance</div>
                        )}

                      {user.balances?.fiat?.length > 0 &&
                        user.balances.fiat.map((fiat, index) => (
                          <div key={`fiat-${index}`}>
                            {fiat.currency}: {fiat.availableBalance}
                          </div>
                        ))}

                      {user.balances?.crypto?.length > 0 &&
                        user.balances.crypto.map((crypto, index) => (
                          <div key={`crypto-${index}`}>
                            {crypto.asset}
                            {crypto.networks?.map((network, netIndex) => (
                              <div key={`network-${index}-${netIndex}`}>
                                ({network.networkName}):{" "}
                                {network.availableBalance}
                              </div>
                            ))}
                          </div>
                        ))}
                    </td>
                    <td>
                      <Link
                        to={`/dashboard/admin/deposit-money/${user._id}`}
                        className="btn btn-primary"
                      >
                        Deposit
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No users found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Deposit;
